import axios from 'axios';

export const getDuplicate = async (payload: any) => {
        let url: any = process.env.REACT_APP_CONTRACT_URL + `/contracts/clone`;
        const requestOptions: any = {
            headers: {
                "Content-type": "application/json",
            },
        }
        const getContracts:any = await axios.post(url, payload,requestOptions);

        return getContracts?.data;
        
    
}